import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Table from './components/Table'
import UserSection from './components/UserSection'
import AddressSection from './components/AddressSection'
import VariablesContextProvider from './contexts/variablesContext'
import SelectedUserContextProvider from './contexts/selectedUserContext'
import SelectedAddressContextProvider from './contexts/selectedAddressContext'

const Conformities = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <SelectedAddressContextProvider>
      <SelectedUserContextProvider>
        <VariablesContextProvider>
          <div>
            <h1>{t('conformities:title')}</h1>
            <Wrapper>
              <AddressSection />
              <UserSection />
            </Wrapper>
            <Table />
          </div>
        </VariablesContextProvider>
      </SelectedUserContextProvider>
    </SelectedAddressContextProvider>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 25px;
  height: 180px;

  .ant-select {
    margin-left: 15px;
  }
`

export default Conformities
